export enum NorceWarehouseCodes {
  Standard = 'STD',
  US = 'US401',
}

export enum NorceProductStatusCodes {
  Active = 'active',
  Coming = 'coming',
  Hidden = 'hidden',
  Expired = 'expired',
  Expiring = 'expiring',
}

export enum NorceProductTypes {
  Standard = 'Standard',
  ExtendedAssortment = 'Extended assortment',
  ManagedStructure = 'ManagedStructure',
  Freight = 'Freight',
  PackingFee = 'Packing fee',
}

export enum NorceCartItemStatusId {
'',
'Active',
'Coming',
'Expiring',
'Hidden',
'Inactive',
'NotActivated',
}

export enum NorceRelatedProductTypeCodes {
  Replacer = 'erstatningsprodukter',
  Upsell = 'Upsell',
  Related = 'related-products',
  BoughtTogether = 'bought-together',
  ColorHydrogen = 'color-hydrogen',
  ColorMaterial = 'color-material',
  ColorBleach = 'color-bleach',
  Installation = 'Installation',
  Mouldings = 'Mouldings',
  Skirtings = 'Skirtings',
  Profiles = 'Profiles',
  Aftercare = 'Aftercare',
  Samples = 'Samples',
  Underlays = 'Underlays',
  Downsell = 'Downsell',
}

export enum NorceMediaSetCodes {
  DefaultImages = 'DEFAULT_IMAGES',
  SecondaryModelImages = 'SECONDARY_MODEL_IMAGES',
  Video = 'PRODUCT_VIDEOS',
  UserManual = 'user_manual',
  Msds = 'msds',
  MainVideo = 'main_video',
  AdditionalImages = 'additional_images',
  DeclarationDocs = 'DeclarationDocs',
  WarrantyDocs = 'WarrantyDocs',
  CADImage = 'CADImage',
  TDS = 'TDS',
  InstallationDocs = 'InstallationDocs',
  CleaningAndMaintenanceDocs = 'CleaningAndMaintenanceDocs',
}

export enum NorceParametricCodes {
  Color = 'COLOR',
  Size = 'SIZE',
  WashingInstructions = 'WASHING',
  SizeGuide = 'SIZE_GUIDE',

  MetaTitle = 'META_TITLE',
  MetaTitleOverride = 'META_TITLE_OVERRIDE',
  MetaDescription = 'META_DESCRIPTION',
  MetaDescriptionOverride = 'META_DESCRIPTION_OVERRIDE',
  DefaultImagesText = 'DEFAULT_IMAGES_TEXT',
  SecondaryModelImagesText = 'SECONDARY_MODEL_IMAGES_TEXT',
  ProductUnavailable = 'PRODUCT_UNAVAILABLE',

  Ingredients = 'ingredients',
  Characteristics = 'egenskaper',
  Volume = 'volume',
  SalesRepNo = 'salesrep-discount-no',
  ProductLayout = 'productLayout',
  ItemTDSlink = 'ItemTDSlink'
}

export enum NorceFlagGroupCodes {
  Promotions = 'PROMOTIONS',
  DisplayFlags = 'displayFlags',
  Splashes = 'splashes',
  ProductStatus = 'productStatus',
  StepCampaigns = 'stepCampaigns',
  GiftCampaigns = 'giftCampaigns',
  PercentageCampaigns = 'percentageCampaigns',
}

export enum NorceFlagCodes {
  DiscontinuedAndVisible = 'discontinuedAndVisible',
  OnDemand = 'onDemand',
  PreOrder = 'preOrder',
  IsNew = 'nyhet',
  Hidden = 'hidden',
}

export enum NorceInfoTypesCodes {
  BasketType = 'basketType',
  SalesRepComment = 'salesRepComment',
  SalesRepDiscount = 'salesRepDiscount',
  PossibleSalesRepGift = 'possibleSalesRepGift',
  PointShopProduct = 'pointShop',
  PointShopValue = 'pointShopValue',
  InvoiceNotice = 'invoiceNotice',
  Comment = 'comment',
  CrossDocking = 'crossDocking',
  DataLayer = 'datalayer',
  CopiedFrom = 'copiedFrom',
  ShipToConsumer = 'ShipToConsumer',
  ShippingComment = 'ShippingComment',
  ShippingAdvice = 'ShippingAdvice',
  DefaultPreferredShippingDate = 'DefaultPreferredShippingDate',
  PreferredShippingDate = 'PreferredShippingDate',
  PONumber = 'PONumber',
  NotificationNumber = 'NotificationNumber',
  NotificationPerson = 'NotificationPerson',
  ExcludeFromCustomerBonus = 'ExcludeFromCustomerBonus',
  TrackTraceName = 'TrackTraceName',
  TrackTraceEmail = 'TrackTraceEmail',
  TrackTracePhone = 'TrackTracePhone',
  TrackTraceMethod = 'TrackTraceMethod',
  AvailableShippingDate = 'AvailableShippingDate',
  MergeShipments = 'MergeShipments',
  GlobalDiscount = 'globalBasketItemDiscount',
  NoContactRequested = 'noContactRequested',
  ResidentialAddress = 'residentialAddress',
  RemoveModBreakCost = 'RemoveModBreakCost',
  TimedUnloadingTime = 'TimedUnloadingTime',
  DestinationType = 'DestinationType',
}

export enum NorceBasketTypes {
  OrderProposal = 'orderProposal',
}

export enum NorceParametricGroupCodes {
  PdpDisplay = 'PDP_DISPLAY',
}

export enum NorceMediaTypes {
  Image = 'image',
  Video = 'video',
}

export enum NorcePriceTypes {
  Standard = 'standard',
  Campaign = 'campaign',
  Agreement = 'agreement',
}

export enum NorceOrderStatusCodes {
  Created = 'CREATED',
  Allocation = 'ALLOCATION',
  Confirmed = 'CONFIRMED',
  BackOrder = 'BACK ORDER',
  Reserved = 'RESERVED',
  Invoiced = 'INVOICED',
  Delivered = 'DELIVERED',
  PartlyDelivered = 'PARTLY DELIVERED',
  Cancelled = 'CANCELLED',
  Aborted = 'ABORTED',
}

export enum NorceUserTypes {
  User = 'user',
  Admin = 'admin',
  Finance = 'finance',
  Sales = 'sales',
  /**
   * this is extremly confusing but a customer support is called customer success
   */
  CustomerSuccess = 'customerSuccess',
}
